export var AiChatRoles;
(function (AiChatRoles) {
    AiChatRoles["User"] = "user";
    AiChatRoles["AI"] = "ai";
    AiChatRoles["Assistant"] = "assistant";
})(AiChatRoles || (AiChatRoles = {}));
export class ChatChoice {
    message;
}
//# sourceMappingURL=ai-record.js.map